import React from 'react';

interface Props {
 
}

const WishList: React.FC<Props> = () => {
  return (
    <div>
      <h1>title</h1>
      <p>Count: count</p>
      {/* Add more JSX as needed */}
    </div>
  );
};

export default WishList;
